<template>
  <video autoplay :controls="false" playsinline muted :poster="props.poster">
    <source :src="props.url" type="video/mp4" />
  </video>
</template>

<script setup lang="ts">
type Props = { url: string; poster?: string }
const props = defineProps<Props>()
</script>

<style></style>
